
<div class="modal-header mfp-header">
    <h5 class="modal-title">Departments</h5>
    <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="Cancel()"
    ></button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="row my-2" *ngFor="let department of Departments; index as i; first as isFirst">
            <div class="col-12 col-md-6"><span *ngIf="isFirst">Departments:</span></div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="department.Name" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6"><span *ngIf="!Departments || !Departments.length">Departments:</span></div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="NewDepartmentName" (blur)="AddDepartment()" />
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="Cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="Save()">Save</button>
</div>
